export default [{
  name: 'landing/rubystone/invitation',
  path: '/landing/rubystone/invitation',
  props: route => ({
    code: route.query.code
  }),
  component: require('@/pages/landing/rubystone/Invitation.vue').default
}]
